'use strict';

const AttachmentView = require('./Attachment.js');
const template = require('employer/templates/governmentForms/LHDNFiles.ejs');
const Payroll        = require('models/Payroll.js');
const loader         = require('helpers/loader');

module.exports = Backbone.View.extend({
    itemViews: null,

    events: {
        'click .js-generate': 'generateForm'
    },

    initialize: function(options) {
        this.itemViews = [];
        this.options = _.defaults(options || {}, {
            attachments: null
        });

        this.options.attachments.on('reset add remove', this.render, this);

        this.render();
    },

    render: function() {
        this.$el.html(template({
            collection: this.options.attachments,
            year: Payroll.getCurrentPeriodDate().getFullYear() - 1
        }));

        if (this.options.attachments.length > 0) {
            this.options.attachments.forEach(this.renderItem.bind(this));
        } else {
            this.$('.empty-list').removeClass('hidden');
        }

        this.$('.sk-spinner').hide();
        return this;
    },

    renderItem: function(model) {
        var view = new AttachmentView({model: model, mainView: this});

        this.itemViews.push(view);
        this.$('.items').append(view.$el);
    },

    generateForm: function(e) {
        loader.startFullScreen(e.target);

        const year = parseInt(this.$('select[name="period-year"]').val(), 10) ||
            new Date().getFullYear();

        return Promise.all(
            this.options.attachments.findByTags([
                'lhdn-audit', `period-${year}`
            ])
            .map(attachment => {
                this.options.attachments.remove(attachment);
                return attachment.destroy();
            })
        ).then(() => this.model.generateLHDNAuditFiles(year))
        .then(() => this.model.fetchAttachments(['lhdn-audit']))
        .then((attachments) => {
            this.options.attachments.add(attachments.models);

            loader.stopLoader();
        });
    },

    remove: function() {
        this.undelegateEvents();
        this.itemViews.forEach(view => view.remove());
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/governmentForms/LHDNFiles.js